export const nameRegex = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
